import { Drawer } from "@components/index";
import { useFiltersDrawerContext } from "@pages/Dashboard/contexts/FiltersDrawer.context";
import { useGanttDataContext } from "@pages/Dashboard/contexts/GanttData.context";
import { useFilteredEventsCount } from "@pages/Dashboard/hooks/useFilteredEventsCount";
import { ChannelsFilter, StatusFilter } from "./components";
import { useFiltersDrawerButtons } from "./components/DrawerActions";
import styles from "./FiltersDrawer.module.scss";
import { useFiltersDrawer } from "./hooks";

function FiltersDrawer() {
  const { open, onClose, drawerFilters, setDrawerFilters } =
    useFiltersDrawerContext();
  const { refreshMap } = useGanttDataContext();
  const { total, filtered } = useFilteredEventsCount();

  const {
    localDrawerFilters,
    handleStatusChange,
    handleChannelChange,
    handleApply,
    handleCancel,
    handleClear,
  } = useFiltersDrawer({
    drawerFilters,
    setDrawerFilters,
    refreshMap,
    onClose,
    open,
  });

  const buttonsFooter = useFiltersDrawerButtons({
    drawerFilters,
    onApply: handleApply,
    onCancel: handleCancel,
    onClear: handleClear,
  });

  return (
    <Drawer
      overlay
      title="Filtros"
      isOpen={open}
      onClose={handleCancel}
      idUsedToOpenDrawer="open-drawer-filters"
      buttonsFooter={buttonsFooter}
    >
      <div className={styles.content}>
        {total > 0 && (
          <div className={styles.counter}>
            {filtered}/{total} processos
          </div>
        )}
        <StatusFilter
          selectedFilters={localDrawerFilters.status}
          onChange={handleStatusChange}
        />

        <ChannelsFilter
          selectedFilters={localDrawerFilters.channels}
          onChange={handleChannelChange}
        />
      </div>
    </Drawer>
  );
}

export default FiltersDrawer;
